<template>
  <div>
    <div class="results-container" v-if="benefits && content">
      <p class="text-center grey--text">Attributes</p>
      <div class="results-container__top">
        <v-chip
          v-for="attr in attributes"
          :key="attr.title"
          class="ma-1"
          :class="attr.color"
        >
          {{ attr.title }}
        </v-chip>
      </div>
      <div class="results-container__middle">
        <div>
          <p class="text-center grey--text">Brand statement</p>
          <h1
            v-text="content.exercise_benefits.step2.phrase"
            class="text-center display-2"
          ></h1>
        </div>
      </div>
      <div class="d-flex flex-row justify-center align-center mb-10">
        <p class="text-center grey--text ma-0 pa-0">Benefits</p>
      </div>

      <div
        class="d-flex flex-row justify-space-between results-container__bottom"
      >
        <div
          v-for="col in flattenedBenefits"
          :key="col.title"
          class="attribute"
        >
          <p class="results-container__bottom__header">
            {{ col.title }}
          </p>
          <v-card
            v-for="(row, index) in col.items"
            :key="`${col.title}-${index}`"
            class="attribute__card mb-5"
          >
            <benefits-card
              :item="row"
              :index="row.index"
              mode="compact"
              :attributes="attributes"
              :showControls="showControls"
              :showDelete="showDelete"
              @edit="edit"
              @remove="remove"
            />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import lodash from "lodash";
import BenefitsCard from "@/views/user/exercises/attributes/BenefitsCard";
const fb = require("@/firebaseConfig.js");

export default {
  name: "ResultsBenefitsSummary",

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
    this.getAudiences();
  },

  data() {
    return {
      content: null,
      audiencesFromExercise: null,
    };
  },
  props: {
    attributes: {
      type: Array,
      default: () => {},
    },
    benefits: {
      type: Array,
      default: () => {},
    },
    showControls: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    lang: {
      type: String,
      default: "exercise_benefits_bl",
    },
  },
  components: { BenefitsCard },

  computed: {
    flattenedBenefits() {
      if (this.benefits) {
        let arr = [];
        const cats = this.audiences;
        cats.forEach((x) => {
          arr.push({
            title: x.title,
            items: this.benefits.filter((y) =>
              y.audience.some((z) => z === x.title)
            ),
          });
        });
        return arr;
      } else {
        return [];
      }
    },

    audiences() {
      if (this.content && this.audiencesFromExercise) {
        console.log("get audiences from exercise");
        return this.content.exercise_benefits.getAudiencesFromExercise
          ? this.audiencesFromExercise
          : this.content.exercise_benefits.step1.dropdown;
      } else {
        return this.content.exercise_benefits.step1.dropdown;
      }
    },
  },

  methods: {
    getAudiences() {
      let ref = fb.audienceExCollection.where(
        "pid",
        "==",
        this.$route.params.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items && items.length) {
            const body = items[0].doc.matrix;
            this.audiencesFromExercise = [...body.q1, ...body.q2, ...body.q3];
          }
        })
        .catch(function() {});
    },
    edit($event) {
      this.$emit("edit", $event);
    },
    remove($event) {
      this.$emit("remove", $event);
    },
  },
};
</script>
